module.exports = __webpack_public_path__ + "static/media/Rectangle 4.0156e3d6.svg";